module.exports = window["Splide"];